import { SafeArea } from 'antd-mobile'
import React from 'react'

function MainPageContainer({ children }) {
    return (
        <div>
            <div style={{ background: '#ace0ff' }}>
                <SafeArea position='top' />
            </div>
            <div
                style={{
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >{children}</div>
            <div style={{ background: '#ffcfac' }}>
                <SafeArea position='bottom' />
            </div>
        </div>

    )
}

export default MainPageContainer